import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const CategoryLegacy = lazy(
  () =>
    import('./CategoryLegacy.eager').then(mod => ({
      default: mod.CategoryLegacy,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
